import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { formatTime } from "../../lib/format";

const time = (iso) => formatTime(iso) || "—";

// ألوان دلالية: حاضر/مكتمل = أخضر، غائب = أحمر، لم ينصرف بعد (open) = أزرق، متأخر = كهرماني.
const TONE = {
  present:   "text-emerald-500",
  completed: "text-emerald-500",
  open:      "text-sky-500",
  absent:    "text-rose-500",
  late:      "text-amber-500",
};

const statusOf = (r) => {
  if (r.status === "absent") return "absent";
  if (!r.check_out_at && r.status !== "completed") return "open";
  return r.status || "present";
};

export const HistoryList = ({ records }) => {
  const { t } = useTranslation();
  return (
    <NeuCard data-testid="history-list" className="animate-rise-in">
      <p className="label-xs">{t("check.history")}</p>
      {records.length === 0 ? (
        <p className="mt-4 text-sm text-muted-foreground">{t("app.none")}</p>
      ) : (
        <ul className="mt-4 space-y-3">
          {records.map((r) => {
            const late = (r.late_minutes || 0) > 0;
            const st = statusOf(r);
            const tone = late ? TONE.late : TONE[st] || "text-muted-foreground";
            const label = late
              ? `${t("check.late")} ${r.late_minutes}'`
              : t(`check.statusValue.${st}`, { defaultValue: st });
            return (
              <li key={r.id}
                  data-testid={`history-row-${r.date}`}
                  className="flex items-center justify-between gap-3 rounded-2xl border border-border/50 px-4 py-3 shadow-neu-sm">
                <span className="font-mono text-sm">{r.date}</span>
                <span className="font-mono text-xs text-muted-foreground">
                  {time(r.check_in_at)} → {time(r.check_out_at)}
                </span>
                <span data-testid={`history-status-${r.date}`} className={`text-xs font-bold ${tone}`}>
                  {label}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </NeuCard>
  );
};
